import React, { useContext, useEffect, useState } from "react";
import {
  Redirect,
  Switch,
  Route,
  useHistory,
} from "react-router-dom";
import { routes } from "../helpers/routes";
import AuthScreen from "./auth/screens/AuthScreen";
import UserProfileScreen from "./main/screens/UserProfileScreen";
import PageNotFound from "./main/screens/PageNotFound";
import ProductPage from "../app/product/screens/ProductScreen";
import { Slide, ToastContainer } from "react-toastify";
import { GlobalStyle } from "./genericComponents/globalStyles";
import { Context } from "../context/globalContext";
import { getUser } from "./auth/services";
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import LateralMenu from "./genericComponents/LateralMenu";
import Header from "./genericComponents/Header";
import MarketplaceScreen from "./marketplace/screens/MarketPlaceScreen";
import PeoplePage from "./people/screens/PeoplePage";
import PaymentPage from "./payments/screen/PaymentScreen";
import MembershipPage from "./membership/screen/UserMembershipPage";
import ExperiencesPage from "./experiences/screen";
import ReactGA from "react-ga";
import { Footer } from "./genericComponents";
import AplicantDatabase from "./aplicantDatabase";
import Schools from "./schools";
import LoaderBals from "./genericComponents/LoaderBals";
import NewsScreen from "./news/screens/NewsScreen";
import Confesions from "./confesions";
import smartlookClient from "smartlook-client";
import moment from "moment";
import { DiscordScreen } from "./discord/screens/DiscordScreen";
import CompleteUserData from "./auth/screens/CompleteUserData";
import OneSignal from "react-onesignal";
import dotenv from "dotenv";
import { trackPage } from "../helpers/analytics";
import RedirectToProfileByEmail from "./genericComponents/RedirectToProfileByEmail";
import { sendPushNotifications } from "../helpers/utils";

export const initGA = () => {
  ReactGA.initialize("UA-183349067-1"); // put your tracking id here
};
export const GApageView = (page) => {
  ReactGA.pageview(page);
};

function AuthRoute({ ...rest }) {
  const { isAuth, accountExpired, userWithOutData } = rest;
  if (isAuth) {
    if (userWithOutData) {
      return <Redirect to={routes.COMPLETEUSERDATA} />;
    }
    if (accountExpired) {
      return <Redirect to={routes.PAYMENT} />;
    }

    return (
      <LateralMenu>
        <Header />
        <Route {...rest} />
        <Footer />
      </LateralMenu>
    );
  } else {
    return <Redirect to={routes.SIGNIN} />;
  }
}

const oneSignalSetup = async (user) => {
  try {
    //console.log("one signal start");
    OneSignal.registerForPushNotifications();
    //console.log("one signal push");

    OneSignal.setExternalUserId(user.email);
    // const onnesignalId = await OneSignal.getPlayerId()
    // console.log("one signal", onnesignalId);
  } catch (e) {
    console.log("onesignal error", e);
  }
};

export default function App() {
  const [initialized, setInitialized] = useState(false);
  const [accountExpired, setAccountExpired] = useState(false);
  const [userWithOutData, setUserWithOutData] = useState(false);
  const [prevPath, setPrevPath] = useState(null);
  const {
    graphQLClient,
    state: { isAuth },
    dispatch: { login },
  } = useContext(Context);

  const history = useHistory();

  useEffect(() => {
    const url_string = window.location.href
    console.log(window.location)
    const url = new URL(url_string);
    const authToken = url.searchParams.get("authToken");
    if(authToken)return verifyCustomToken(authToken,`${window.location.pathname}`);
    initialFlow();
  }, []);

  function initialFlow() {
    
    smartlookClient.init("50640e5c38de96d16abe0bba51658b5302b27cfe");
    OneSignal.initialize(process.env.REACT_APP_ONESIGNAL_API_KEY, {
      autoRegister: true,
    });

    firebase.auth().onAuthStateChanged(async (user) => {
      if (!user) {
        setInitialized(true);
      } else {
        const userData = await getUser(graphQLClient, user.email || "");
        if (userData.userAccount) {
          setUserWithOutData(false);
        } else {
          setUserWithOutData(true);
        }
        // console.log("userData", userData);
        if (
          !moment(userData?.userAccount?.due_date).isAfter(
            moment(firebase.firestore.Timestamp.now().toMillis())
          )
        ) {
          setAccountExpired(true);
        }
        login(userData);
        //window.$crisp.push(["set", "user:email", [user.email]]);
        //window.$crisp.push([
          //"set",
          //"user:nickname",
          //[`${userData.name} ${userData.last_name}`],
        //]);
        await oneSignalSetup(user);
        setInitialized(true);
      }
    });
  }
  async function verifyCustomToken(authToken,finalpath){
    await firebase.auth().signInWithCustomToken(authToken).catch(e=>console.log('..................',e))
    history.push(finalpath)
    initialFlow();
  }

  useEffect(() => {
    return history?.listen((location) => {
      console.log("analytic page", location.pathname);
      window.analytics.page(location.pathname);
    });
  }, [history]);

  if (!initialized) return <LoaderBals />;

  return (
    <>
      <GlobalStyle />
      <ToastContainer
        autoClose={3000}
        transition={Slide}
        newestOnTop
        closeOnClick
        pauseOnHover={false}
        draggable
      />
      {/* <Router history={history}> */}
      <Switch>
        <Route exact path={routes.SIGNIN}>
          <AuthScreen isAuth={isAuth} />
        </Route>
        <Route exact path={routes.SIGNUP}>
          <AuthScreen isAuth={isAuth} />
        </Route>
        <AuthRoute
          exact
          isAuth={isAuth}
          path={routes.COMPLETEUSERDATA}
          component={CompleteUserData}
        />
        <AuthRoute
          exact
          isAuth={isAuth}
          userWithOutData={userWithOutData}
          accountExpired={accountExpired}
          path={routes.USER}
          component={UserProfileScreen}
        />
        <AuthRoute
          exact
          isAuth={isAuth}
          userWithOutData={userWithOutData}
          accountExpired={accountExpired}
          path={routes.MARKET_PLACE}
          component={MarketplaceScreen}
        />
        <AuthRoute
          exact
          isAuth={isAuth}
          userWithOutData={userWithOutData}
          path={routes.PAYMENT}
          component={PaymentPage}
        />
        <AuthRoute
          exact
          isAuth={isAuth}
          userWithOutData={userWithOutData}
          path={routes.MEMBERSHIP}
          component={MembershipPage}
        />
        <AuthRoute
          exact
          isAuth={isAuth}
          userWithOutData={userWithOutData}
          accountExpired={accountExpired}
          path={routes.PRODUCT}
          component={ProductPage}
        />
        <AuthRoute
          exact
          isAuth={isAuth}
          userWithOutData={userWithOutData}
          accountExpired={accountExpired}
          path={routes.PEOPLE}
          component={PeoplePage}
        />
        <AuthRoute
          exact
          isAuth={isAuth}
          userWithOutData={userWithOutData}
          accountExpired={accountExpired}
          path={routes.SCHOOLS}
          component={Schools}
        />
        <AuthRoute
          exact
          isAuth={isAuth}
          userWithOutData={userWithOutData}
          accountExpired={accountExpired}
          path={routes.APLICANTDB}
          component={AplicantDatabase}
        />
        <AuthRoute
          exact
          isAuth={isAuth}
          userWithOutData={userWithOutData}
          accountExpired={accountExpired}
          path={routes.NEWS}
          component={NewsScreen}
        />
        <AuthRoute
          exact
          isAuth={isAuth}
          userWithOutData={userWithOutData}
          accountExpired={accountExpired}
          path={routes.CONFESSIONS}
          component={Confesions}
        />
        <AuthRoute
          exact
          isAuth={isAuth}
          userWithOutData={userWithOutData}
          accountExpired={accountExpired}
          path={routes.EXPERIENCES}
          component={ExperiencesPage}
        />
        <AuthRoute
          exact
          isAuth={isAuth}
          userWithOutData={userWithOutData}
          accountExpired={accountExpired}
          path={routes.REDIRECT_BY_EMAIL}
          component={RedirectToProfileByEmail}
        />
        <AuthRoute
          exact
          isAuth={isAuth}
          userWithOutData={userWithOutData}
          accountExpired={accountExpired}
          path={routes.DISCORD}
          component={DiscordScreen}
        />
        <Route path={routes.PAGE_NOT_FOUND}>
          <PageNotFound />
        </Route>
      </Switch>
      {/* </Router> */}
    </>
  );
}